import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import StepsSection from "./components/StepsSection";
import ValuesSection from "./components/ValuesSection";
import FeaturesSection from "./components/FeaturesSection";
import ComparisonSection from "./components/ComparisonSection";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <StepsSection />
        <ValuesSection />
        <FeaturesSection />
        <ComparisonSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
